// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"694e32cf","767":"694e32cf"}[chunkId] + ".chunk.css";
};